import { render } from "./Sidebar.vue?vue&type=template&id=35544446&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=35544446&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35544446"]])

export default __exports__